import { AppComponent } from './app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { Store } from '@ngxs/store';
import { of } from 'rxjs';

class DummyStore {
  select() {
    return of(null);
  }

  dispatch() {
    return of(null);
  }
}
appConfig.providers.push({ provide: Store, useClass: DummyStore } );


bootstrapApplication(AppComponent, appConfig)
  .catch(err => console.error(err));
